var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2.333C7.557 2.333 2.333 7.557 2.333 14S7.557 25.667 14 25.667 25.667 20.443 25.667 14 20.443 2.333 14 2.333z",
    fill: "#90ECF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.989 11.084a1.166 1.166 0 11-2.02-1.168 3.5 3.5 0 016.531 1.75c0 1.281-.786 2.327-1.75 2.917-.775.474-.292 1.75-1.753 1.75a1.167 1.167 0 01-1.16-1.288c.032-.617.307-1.119.607-1.484a4.19 4.19 0 011.05-.89c1.77-1.051-.389-3.203-1.505-1.587zm1.008 6.416a1.167 1.167 0 100 2.333 1.167 1.167 0 000-2.333z",
    fill: "#444BD3"
  })));
}
export default SvgQuestionMark;